module.exports = __webpack_public_path__ + "img/atlantic-shark-institute-square2.030b50f4.png";